module.exports = __webpack_public_path__ + "static/media/banner-min.711d5b37.jpg";